export default "__VITE_ASSET__RjLzvIz4__"